/**
 * Sorts an array of objects based on a given comparison function.
 *
 * @param {Array<Object>} array The array of objects to sort.
 * @param {Function} function The comparison function to determine the order of the objects based on the condition.
 * @returns {Array<Object>} The sorted array.
 */
const sortArrayByCondition = (array: any[], comparator, key: string) => {
  const passed = array.filter(item => comparator(item))

  const notPassed = array.filter(
    item => !passed.some(passedItem => passedItem[key] === item[key])
  )

  return passed.concat(notPassed)
}

export default sortArrayByCondition
